import { useQuery } from "@tanstack/react-query";
import type { Moment } from "moment-timezone";
import type { WeeklyIncentiveData } from "../../models/WeeklyIncentiveData";
import { getProductionDateIncentive } from "../../repositories/IncentiveRepository";
import { incentiveRealtimeTopic } from "../realtime/incentiveRealtimeTopic";

export const useProductionDateIncentiveQuery = (
	productionDate: Moment,
	assetId: number,
) => {
	const productionDateStr = productionDate.format("YYYY-MM-DD");

	return useQuery<WeeklyIncentiveData, Error>({
		queryKey: ["incentive", assetId, productionDateStr],
		meta: { realtime: [incentiveRealtimeTopic(assetId, "GetIncentiveByWeek")] },
		queryFn: ({ signal }) =>
			getProductionDateIncentive(productionDateStr, assetId, signal),
		refetchInterval: 60_000,
		refetchOnWindowFocus: true,
	});
};
